import { FC } from 'react';
import { Control, FieldValues, UseFormSetError, UseFormSetValue, UseFormWatch } from 'react-hook-form';

import { PaymentMethod } from 'types';
import Deposit from './Deposit';
import Withdraw from './Withdraw';

const PayKassma: FC<{
  isDeposit: boolean;
  onClose: () => void;
  getValues: () => FieldValues;
  paymentMethod: PaymentMethod;
  watch: UseFormWatch<FieldValues>;
  control: Control<FieldValues, unknown>;
  setError: UseFormSetError<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  changeAmountFieldVisibility: (isVisible: boolean) => void;
  changeActionButtonVisibility: (isVisible: boolean) => void;
  changeActionButtonAvailability: (isAvailability: boolean) => void;
}> = ({
  watch,
  control,
  setError,
  setValue,
  isDeposit,
  paymentMethod,
  changeAmountFieldVisibility,
  changeActionButtonVisibility,
  changeActionButtonAvailability,
}) => {
  if (isDeposit) {
    return (
      <Deposit
        watch={watch}
        control={control}
        paymentMethod={paymentMethod}
        changeAmountFieldVisibility={changeAmountFieldVisibility}
        changeActionButtonVisibility={changeActionButtonVisibility}
      />
    );
  }

  return (
    <Withdraw
      watch={watch}
      control={control}
      setError={setError}
      setValue={setValue}
      paymentMethod={paymentMethod}
      changeAmountFieldVisibility={changeAmountFieldVisibility}
      changeActionButtonVisibility={changeActionButtonVisibility}
      changeActionButtonAvailability={changeActionButtonAvailability}
    />
  );
};

export default PayKassma;
